import React, { Fragment } from 'react'
import styles from './pupils-filter-controls.styles'
import injectSheet from 'react-jss'

const PupilsFilterControls = ({
  classes,
  selectedGroups,
  onEdit,
  onReset,
  onSelectGroups
}) => (
  <ul className={classes.container}>
    {!selectedGroups.length && (
      <li>
        <span className={classes.actionLink} onClick={onSelectGroups}>
          Select groups
        </span>
      </li>
    )}
    {!!selectedGroups.length && (
      <Fragment>
        <li>
          <span className={classes.title}>Groups selected:</span>
          <span className={classes.firstGroup}>
            {selectedGroups[0] && selectedGroups[0].title}
          </span>
          {selectedGroups.length > 1 && (
            <span className={classes.otherGroups}>
              and {selectedGroups.length - 1} other
              {selectedGroups.length > 2 ? 's' : ''}
            </span>
          )}
        </li>
        <li>
          <span className={classes.actionLink} onClick={onEdit}>
            Edit
          </span>
        </li>
        <li>
          <span className={classes.actionLink} onClick={onReset}>
            Reset
          </span>
        </li>
      </Fragment>
    )}
  </ul>
)

export default injectSheet(styles)(PupilsFilterControls)
